module.exports = __webpack_public_path__ + "static/oracle-web-8e0aec9c21d040eccd62ccf9d2c3c1a2.jpg";